var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checklistData)?_c('div',{staticClass:"checklist checklist--preview"},[(!_vm.checklistData.valid)?_c('div',{staticClass:"checklist__error"},[_vm._v("\n\t\t"+_vm._s(_vm.checklistData.message)+"\n\t")]):_c('checklist-items',{attrs:{"data":_vm.checklist,"title":'Checklist Preview'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }